import {
    getCampaigns as __getCampaigns,
    getAppointmentNoteCategoryParents as __getAppointmentNoteCategoryParents,
    getDealers as __getDealers,
    getTimeSlots as __getTimeSlots,
    sendVerificationCode as __sendVerificationCode,
    getVerificationCode as __getVerificationCode,
    sendVerificationCodeWOLogin as __sendVerificationCodeWOLogin,
    getVerificationCodeWOLogin as __getVerificationCodeWOLogin,
    getFormerDealer as __getFormerDealer,
    createAppointment as __createAppointment,
    getCustomer as __getCustomer,
    cancelAppointment as __cancelAppointment,
    getAppointmentDetail as __getAppointmentDetail,
} from './services'

import {
    getCampaigns as _getCampaigns,
    getAppointmentNoteCategoryParents as _getAppointmentNoteCategoryParents,
    getDealers as _getDealers,
    getTimeSlots as _getTimeSlots,
    sendVerificationCode as _sendVerificationCode,
    getVerificationCode as _getVerificationCode,
    sendVerificationCodeWOLogin as _sendVerificationCodeWOLogin,
    getVerificationCodeWOLogin as _getVerificationCodeWOLogin,
    getFormerDealer as _getFormerDealer,
    createAppointment as _createAppointment,
    getCustomer as _getCustomer,
    cancelAppointment as _cancelAppointment,
    getAppointmentDetail as _getAppointmentDetail,
} from './services.dummy'

const isDevelopment = process.env.REACT_APP_ENV === 'development'


const getCampaigns = isDevelopment ? _getCampaigns : __getCampaigns
const getAppointmentNoteCategoryParents = isDevelopment ? _getAppointmentNoteCategoryParents : __getAppointmentNoteCategoryParents
const getDealers = isDevelopment ? _getDealers : __getDealers
const getTimeSlots = isDevelopment ? _getTimeSlots : __getTimeSlots
const sendVerificationCode = isDevelopment ? _sendVerificationCode : __sendVerificationCode
const getVerificationCode = isDevelopment ? _getVerificationCode : __getVerificationCode
const sendVerificationCodeWOLogin = isDevelopment ? _sendVerificationCodeWOLogin : __sendVerificationCodeWOLogin
const getVerificationCodeWOLogin = isDevelopment ? _getVerificationCodeWOLogin : __getVerificationCodeWOLogin
const getFormerDealer = isDevelopment ? _getFormerDealer : __getFormerDealer
const createAppointment = isDevelopment ? _createAppointment : __createAppointment
const getCustomer = isDevelopment ? _getCustomer : __getCustomer
const cancelAppointment = isDevelopment ? _cancelAppointment : __cancelAppointment
const getAppointmentDetail = isDevelopment ? _getAppointmentDetail : __getAppointmentDetail


// TODO: this needs refactoring, probably not a good practice
export {
    getCampaigns,
    getAppointmentNoteCategoryParents,
    getDealers,
    getTimeSlots,
    sendVerificationCode,
    getVerificationCode,
    sendVerificationCodeWOLogin,
    getVerificationCodeWOLogin,
    getFormerDealer,
    createAppointment,
    getCustomer,
    cancelAppointment,
    getAppointmentDetail
}